import SearchForm from './SearchForm.vue'

export default SearchForm
